import moment from "moment"
import { storageListSelect, listNotLeavelStaffByStoreId, locationSkuList } from "@/utils/api"
export const comeWarehouse = {
    data() {
        return {
            warehouseList: [], // 出库仓库列表
            agentList: [], // 经办人列表
            dataSource: [{
                id: '001'
            }, {
                id: '002'
            }, {
                id: '003'
            }, {
                id: '004'
            }, {
                id: '005'
            }, {
                id: '006'
            }, {
                id: '007'
            }, {
                id: '008'
            }, {
                id: '009'
            }, {
                id: '010'
            }, {
                id: '011'
            }, {
                id: '012'
            }, {
                id: '013'
            }, {
                id: '014'
            }, {
                id: '015'
            }, {
                id: '016'
            }, {
                id: '017'
            }, {
                id: '018'
            }],
            footerDataSource: [],
            skuIdList: [],
            formData: {
                outboundCode: '', // 出库单号
                outboundDate: '', // 出库日期

                contactCustomerId: '', // 往来单位id
                contactCustomerName: '', // 往来单位名称

                storageId: '', // 发货仓库id
                storageName: undefined, // 发货仓库名称

                transactorId: '', // 经办人id
                transactorName: undefined, // 经办人名称

                digest: '', // 摘要
                remark: '', // 备注

                contactCustomerAddressId: '', // 往来单位收货地址id
                contactCustomerAddressName: '', // 往来单位收货地址
                resourceIdList: [], // 资源idList
                resourceList: [],
                attachmentFlag: 0,

                itemList: [],

                distributionMode: '1', // 配送方式 1：客户自提，2：送货上门
                includeFreightFlag: 0, //  是否包含运费 0：否，1：是

                logisticsCompanyId: '', //  物流公司id
                logisticsCompanyName: '', //  物流公司名称
                trackingNumber: '', // 运单号

                outboundType: 0, //出库类型(0-销售出库 1-其他出库 2-采购退货出库 3-库存调拨出库 4-库存报损出库 5-组装拆卸出库 6-期初库存调整出库)
                sourceOfBusiness: 1,
            },

            outboundDate: undefined,
            locationListAll: [], // 库位列表

            contentHeight: '',
            tableHeight: '', // 表格高度
            tdIndex: null, // 记录初始输入框的位置
        }
    },
    methods: {
        init() {
            // 表格高度计算
            let _that = this
            setTimeout(function () {
                let header = document.getElementById("header").offsetHeight;
                let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
                let pageHeight = document.getElementById('content').offsetHeight
                let makeTop = document.getElementById('page-top').offsetHeight
                let makeButton = document.getElementById('page-button').offsetHeight
                let tdHeight = header * 0.7
                _that.contentHeight = pageHeight - makeTop - makeButton - header - breadcrumb - tdHeight * 1.24
                _that.tableHeight = _that.contentHeight - tdHeight * 2
            }, 50)
            this.tableAddTotalRow(this.columns, this.dataSource)
            this.getStorageList()
            this.getStaffListSelect()
            this.getCurrentData()
        },
        //   设置日期
        getCurrentData() {
            let date = this.$comm.getNowFormatDate()
            this.outboundDate = moment(date)
            this.formData.outboundDate = date
        },
        // 选择日期
        onChangeDate(date, dateString) {
            this.outboundDate = moment(dateString)
            this.formData.outboundDate = dateString
        },
        // 获取仓库列表
        getStorageList() {
            let params = new FormData()
            params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
            storageListSelect(params).then((res) => {
                if (res.code == 200) {
                    this.warehouseList = res.result
                    let storageNameData = JSON.parse(localStorage.getItem('outStorageName'))
                    if (storageNameData && !this.$route.query.id) {
                        this.formData.storageId = storageNameData.outStorageId
                        this.formData.storageName = storageNameData.outStorageName
                    }
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        // 选择仓库
        selectWarehouse(e) {
            this.formData.storageId = this.warehouseList[e].id
            this.formData.storageName = this.warehouseList[e].storageName
            localStorage.setItem('outStorageName', JSON.stringify({
                outStorageId: this.formData.storageId,
                outStorageName: this.formData.storageName
            }))
            if (this.skuIdList.length > 0) {
                this.getLocationName()
            }
        },
        // 获取经办人列表
        getStaffListSelect() {
            let params = new FormData()
            params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
            listNotLeavelStaffByStoreId(params).then((res) => {
                if (res.code == 200) {
                    this.agentList = res.result
                    let transactorNameData = JSON.parse(localStorage.getItem('transactorName'))
                    if (transactorNameData && !this.$route.query.id) {
                        this.formData.transactorId = transactorNameData.transactorId
                        this.formData.transactorName = transactorNameData.transactorName
                    }
                } else {
                    this.$message.error(res.logMessage)
                }
            })
        },
        // 选择经办人
        selectAgentList(e) {
            this.formData.transactorId = this.agentList[e].id
            this.formData.transactorName = this.agentList[e].name
            localStorage.setItem('transactorName', JSON.stringify({
                transactorId: this.formData.transactorId,
                transactorName: this.formData.transactorName
            }))
        },

        // 选择地址
        selectAddress(data) {
            this.formData.contactCustomerAddressId = data.id
            this.formData.contactCustomerAddressName = data.detailAddress
        },
        // 上传附件
        onChangeFile(data) {
            this.formData.resourceIdList = []
            if (data.length > 0) {
                this.formData.attachmentFlag = 1
                data.map(item => {
                    if (item.orderId) {
                        this.formData.resourceIdList.push(item.resourceId)
                    } else {
                        this.formData.resourceIdList.push(item.id)
                    }
                })
            } else {
                this.formData.attachmentFlag = 0
            }
        },

        /** 表格增加合计行 */
        tableAddTotalRow(columns, dataSource) {
            let numKey = 'rowIndex'
            let totalRow = {
                [numKey]: '小计'
            }
            this.footerDataSource = []
            columns.forEach(column => {
                let { key, dataIndex } = column
                if (![key, dataIndex].includes(numKey)) {
                    let total = 0
                    dataSource.forEach(data => {
                        if (dataIndex == 'totalAmount') {
                            if (data[dataIndex]) {
                                total += Number(data[dataIndex])
                            }
                        } else if (dataIndex == 'productCount') {
                            if (data[dataIndex]) {
                                total += Number(data[dataIndex])
                            }
                        } else {
                            total = ''
                        }
                    })
                    totalRow[dataIndex] = total
                }
            })
            totalRow.totalAmount = totalRow.totalAmount.toFixed(2)
            this.formData.totalAmount = totalRow.totalAmount
            this.formData.productTotalCount = totalRow.productTotalCount
            this.footerDataSource.push(totalRow)
        },

        // 备注回车
        pressEnterRemark() {
            if (this.dataSource[0].status == 1) {
                let text = ''
                let record = {
                    status: 1
                }
                let index = 0
                this.btnChangeState(text, record, index)
            } else {
                let text = ''
                let record = {
                    status: 1
                }
                let index = 0
                for (let i = 0; i < this.dataSource.length; i++) {
                    if (this.dataSource[i].status == 1) {
                        index = i
                        break
                    }
                }
                this.btnChangeState(text, record, index)
            }
        },

        // 回车事件
        pressEnter(e) {
            if (this.isEmpty(this.formData.contactCustomerId)) {
                this.$message.warning('请先选择往来单位')
                return;
            } else if (this.isEmpty(this.formData.storageId)) {
                this.$message.warning('请先选择出库仓库')
                return;
            }
            this.$refs.commodity.onOpen(this.dataSource, e.target.value)
        },

        // 从报价单来的销售出库单
        makeConfirmParts(data) {
            this.skuIdList = []
            this.dataSource = []
            //  将未重复的添加进去
            data.map((item, index) => {
                if (!item.repetition) {
                    this.dataSource.push({
                        businessVoucherCode: item.salesOrderCode, // 关联单据单号
                        businessVoucherId: item.salesOrderId, // 关联单据id
                        assemblyFlag: Number(item.assemblyFlag),
                        giftFlag: item.giftFlag, //  是否赠品 0否 1是
                        price: Number(item.price), //  价格
                        productCode: item.productCode, // 商品编号
                        productId: item.productId, // 商品id
                        productModel: item.productModel, // 产品型号
                        productName: item.productName, // 商品名称
                        productSkuId: item.productSkuId, // 商品属性id
                        productSpecification: item.productSpecification, // 产品规格
                        productCount: item.productTotalCount, // 数量 
                        productUnit: item.productUnitName, // 单位
                        productUnitId: item.productUnitId,
                        remark: item.remark, // 备注
                        totalAmount: Number(item.totalAmount), // 总价
                        locationIdStr: '',
                        locationName: '',
                        isRemarkShow: false, // 备注输入框显示隐藏控制
                        isLocationShow: false, // 出库库位 
                        isDigest: false, // 摘要
                    })
                    this.skuIdList.push(item.productSkuId)
                }
            })
            this.setDataSource()
        },
        // 设置数据
        setDataSource() {
            this.dataSource.map(item => {
                item.price = this.$comm.toDecimal2(item.price)
                item.totalAmount = this.$comm.toDecimal2(item.totalAmount)
            })
            if (this.skuIdList.length > 0) {
                this.getLocationName()
            }
            //   在数据未满8条的情况下添加空白
            if (this.dataSource.length < 18) {
                for (let i = this.dataSource.length; i < 18; i++) {
                    this.dataSource.push({
                        status: 1,
                        statusCode: 1
                    })
                }
            } else {
                this.dataSource.push({
                    status: 1,
                    statusCode: 1
                })
            }
            // 计算总价
            this.tableAddTotalRow(this.columns, this.dataSource)
        },

        // 获取初始库为信息
        getLocationName() {
            if (this.formData.storageId) {
                locationSkuList(this.skuIdList, {}, {
                    companyStoreId: this.$store.state.shopId,
                    storageId: this.formData.storageId
                }).then((res) => {
                    if (res.success) {
                        res.result.map((item, index) => {
                            this.dataSource.map((ite, inde) => {
                                if (item.skuId == ite.productSkuId) {
                                    this.dataSource[inde].locationIdStr = item.locationIdStr
                                    this.dataSource[inde].locationName = item.locationName
                                }
                            })
                        })
                    }
                })
            }
        },

        // 选择库位下拉框
        btnOpenLocationSelect(record, index) {
            this.selectLocation = !this.selectLocation
            if (this.selectLocation) {
                this.$refs.storageLocation.onOpen(record, index, this.formData.storageId)
            } else {
                this.$refs.storageLocation.confirmCancel(1)
            }
        },
        // 关闭选择库位下拉框
        confirmCancel(data) {
            this.selectLocation = fals
            if (data.confirm == 'confirm') {
                this.dataSource[data.index].locationIdStr = ''
                this.dataSource[data.index].locationName = ''
                data.selectObj.map(item => {
                    this.dataSource[data.index].locationName += item + ';'
                })
                data.selectId.map(item => {
                    this.dataSource[data.index].locationIdStr += item + ','
                })
            }
            this.dataSource[data.index].isLocationShow = false
            this.btnShowInput(this.dataSource[data.index], data.index, 10)
        },

        // 改变文本为输入框
        btnShowInput(record, index, type) {
            if (this.tdIndex == index || this.tdIndex == null) {
                if (type == 9) {
                    if (this.formData.storageId) {
                        this.selectLocation = false
                        this.dataSource[index].isPriceShow = false
                        this.dataSource[index].isLocationShow = true
                        this.locationleft = document.getElementById('warehouse-location').parentElement.offsetLeft
                    } else {
                        this.$message.warning('请先选择出库仓库')
                    }
                } else if (type == 10) {
                    this.dataSource[index].isLocationShow = false
                    this.dataSource[index].isRemarkShow = true
                }
                this.dataSource.splice(index, 1, this.dataSource[index])
                this.tdIndex = index
            } else {
                if (type == 9) {
                    if (this.formData.storageId) {
                        this.selectLocation = false
                        this.dataSource[this.tdIndex].isPriceShow = false
                        this.dataSource[this.tdIndex].isLocationShow = false
                        this.dataSource[index].isLocationShow = true
                        this.locationleft = document.getElementById('warehouse-location').parentElement.offsetLeft
                    } else {
                        this.$message.warning('请先选择出库仓库')
                    }
                } else if (type == 10) {
                    this.dataSource[this.tdIndex].isLocationShow = false
                    this.dataSource[this.tdIndex].isRemarkShow = false
                    this.dataSource[index].isRemarkShow = true
                }
                this.dataSource.splice(index, 1, this.dataSource[index])
                this.tdIndex = index
            }
        },
        btnShowInputRemark(text, record, index) {
            if (this.dataSource[index + 1].productName) {
                this.btnShowInput(this.dataSource[index + 1], index + 1, 5)
            } else {
                this.btnChangeState(text, this.dataSource[index + 1], index + 1)
            }
        },
        // 选择是否送货上门
        changeLogistics(e) {
            this.formData.distributionMode = e.target.value
        },
        // 选择物流公司
        btnLogistics() {
            this.$refs.popover.show()
        },
        // 选择物流公司回调
        getlogisticsinfo(data, type) {
            this.formData.logisticsCompanyId = data.id
            this.formData.logisticsCompanyName = data.name
        },

        // 取消退出
        onClickButton(item) {
            if (item.id == 1) { // 点击取消退出
                this.$refs.footer.testingRequired(item.id)
            } else if (item.id == 2) { // 点击回到上一页
                this.$router.go(-1)
                // this.$store.state.closePath = this.$route.fullPath;
            } else { // 验证必填数据是否填写
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if (this.dataSource[0].productName) {
                            this.$refs.footer.testingRequired(item.id)
                        } else {
                            this.$message.warning("请先选择商品")
                        }
                    } else {
                        return false;
                    }
                })
            }
        }
    }
}